import { database, auth } from '@/firebase';

const {
  updateRecord,
  addToArray,
  removeFromArray,
} = database;

const {
  sendLoginLink,
  signIn,
  signOut,
  getUser,
  updateUser,
  deleteUser,
} = auth;


export default {
  signIn({ commit }, email) {
    return signIn(email).then(() => {
      const user = getUser();
      commit('set', { model: 'user', value: user });
      if (user.isAdmin) {
        commit('set', { model: 'mode', value: 'admin' });
      }
    });
  },
  updateUser({ commit }, { displayName }) {
    return updateUser({ displayName }).then(() => {
      commit('set', { model: 'user', value: getUser() });
    });
  },
  deleteUser({ commit }) {
    return deleteUser().then(() => {
      commit('set', { model: 'user', value: null });
    });
  },
  sendLoginLink(state, email) {
    // To do: Save request record
    return sendLoginLink(email);
  },
  signOut({ commit }) {
    commit('set', { model: 'user', value: null });
    commit('set', { model: 'mode', value: 'reader' });
    return signOut();
  },
  addAdmin({ dispatch }, email) {
    return updateRecord({
      model: 'site',
      id: 'admin',
      value: {
        users: addToArray(email),
      },
    }).then(() => dispatch('fetchSite'));
  },
  removeAdmin({ dispatch }, email) {
    return updateRecord({
      model: 'site',
      id: 'admin',
      value: {
        users: removeFromArray(email),
      },
    }).then(() => dispatch('fetchSite'));
  },
};
